import React, { useCallback, useMemo, useState } from "react";
import { EmailStep } from "../EmailStep/EmailStep";
import { CodeStep } from "../CodeStep/CodeStep";

const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

const checkEmail = (value) => emailRegex.test(value);

export const AuthForm = ({ handleCloseButtonClick, setStepForm }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formState, setFormState] = useState({
    email: { value: "", error: null },
    code: { value: "", error: null },
    isUserExists: false,
  });

  const handleChange = useCallback((name, value) => {
    setFormState((prev) => ({ ...prev, [name]: { value, error: null } }));
  }, []);

  const setError = (fieldName, value) => {
    setFormState((prev) => {
      const newState = { ...prev };

      if (fieldName === "code") {
        newState[fieldName] = { value: "", error: value };
      } else {
        newState[fieldName] = { ...prev[fieldName], error: value };
      }

      return newState;
    });
  };

  const validate = useCallback(
    (data) => {
      if (currentStep === 0) {
        const email = data.email;

        const emailIsValid = checkEmail(email);

        if (!emailIsValid) {
          setError("email", "Некорректный формат почты");
          return false;
        }
      }

      return true;
    },
    [currentStep],
  );

  const handleSubmit = useCallback(
    (cb) => (event) => {
      event.preventDefault();

      const data = Object.keys(formState).reduce(
        (acc, key) => ({
          ...acc,
          [key]: formState[key].value,
        }),
        {},
      );

      const isValid = validate(data);

      if (!isValid) {
        return;
      }

      return cb(data, event);
    },
    [formState, validate],
  );

  const nextStep = useCallback(
    (isUserExists) => {
      setFormState((prev) => ({ ...prev, isUserExists }));

      const newStep = currentStep + 1;
      setCurrentStep(newStep);
      setStepForm(newStep);
    },
    [currentStep, setStepForm],
  );

  const stepComponent = useMemo(() => {
    const steps = [
      <EmailStep
        key="email"
        field={formState["email"]}
        onChange={(e) => handleChange("email", e.target.value)}
        nextStep={nextStep}
        handleSubmit={handleSubmit}
        onClose={handleCloseButtonClick}
        setError={setError}
      />,
      <CodeStep
        key="code"
        email={formState["email"].value}
        field={formState["code"]}
        isUserExists={formState["isUserExists"]}
        onChange={(value) => handleChange("code", value)}
        handleSubmit={handleSubmit}
        onClose={handleCloseButtonClick}
        setError={setError}
      />,
    ];

    return steps[currentStep];
  }, [
    handleCloseButtonClick,
    currentStep,
    formState,
    handleChange,
    handleSubmit,
    nextStep,
  ]);

  return stepComponent;
};
